import "./organization-access-lists.scss";

import React, { useState, useEffect, useCallback } from "react";
import {
  GSListPage,
  GSInput,
  GSItemList,
  GSEmptyList,
} from "golfstatus_react_components";
import {
  faTimesCircle,
  faPlus,
  faSearch,
} from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentOrganization } from "../../reducers/organizationSlice";
import { Outlet, useNavigate } from "react-router-dom";
import { useMatch } from "react-router-dom";

import {
  getOrganizationAccessLists,
  selectLoading,
  selectOrganizationAccessLists,
} from "../../reducers/accessSlice";
import OrganizationAccessListItem from "./organization-access-list-item";

const OrganizationAccessLists = () => {
  const dispatch = useDispatch();
  const currentOrganization = useSelector(selectCurrentOrganization);
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const match = useMatch("/:id/access/*");
  const loading = useSelector(selectLoading);
  const accessLists = useSelector(selectOrganizationAccessLists);

  const loadData = useCallback(() => {
    if (currentOrganization.id) {
      dispatch(getOrganizationAccessLists(currentOrganization?.id));
    }
  }, [dispatch, currentOrganization]);

  useEffect(() => {
    loadData();
  }, [loadData, currentOrganization]);

  const clearText = () => {
    setName("");
  };

  const searchChanged = (e) => {
    setName(e.target.value);
  };

  const addList = () => {
    navigate("add");
  };

  const editList = (list) => {
    if (!isSidePanelOpen()) {
      navigate(`${list.id}`);
    } else {
      navigate(``);
    }
  };

  const getPageActions = () => {
    return [
      {
        buttonTitle: "Add List",
        type: "black mobile-icon",
        actionIcon: faPlus,
        actionClick: addList,
      },
    ];
  };
  const isSidePanelOpen = () => {
    return match?.params?.["*"] !== "";
  };
  const getRouter = () => {
    return <Outlet />;
  };
  const getListPage = (title) => {
    const page = {
      title: title,
      getDefaultSearch: getDefaultSearch,
      getItemList: getItemList,
      getPageActions: getPageActions,
      isSidePanelOpen: isSidePanelOpen,
      getRouter: getRouter,
    };
    return <GSListPage {...page} />;
  };
  const getEmptyListMessage = () => {
    return (
      <GSEmptyList
        title="Add & Manage Access Lists"
        detail="Access lists allow you to limit event registration and reserve packages for specific registrants."
        actions={[
          {
            title: "Add List",
            onClick: addList,
            buttonIcon: faPlus,
            type: "black",
          },
        ]}
      />
    );
  };
  const getEmptySearchMessage = () => {
    return (
      <GSEmptyList
        title="We couldn’t find the access list you’re looking for…"
        detail="Try changing the search term or add a new access list."
        actions={[
          {
            title: "Clear Search",
            onClick: clearText,
            type: "light-grey",
          },
          {
            title: "Add List",
            onClick: addList,
            buttonIcon: faPlus,
            type: "black",
          },
        ]}
      />
    );
  };

  const getFilteredLists = () => {
    return accessLists?.filter?.((list) =>
      list?.name?.toLowerCase?.()?.includes?.(name?.toLowerCase())
    );
  };
  const getItemList = () => {
    return (
      <GSItemList
        items={getFilteredLists()}
        listItem={(list) => <OrganizationAccessListItem {...list} />}
        type="vertical selectable"
        emptyMessage={name ? getEmptySearchMessage() : getEmptyListMessage()}
        itemSelected={editList}
        loading={loading?.includes?.("getOrganizationAccessLists")}
        loadingMainText="Loading"
      ></GSItemList>
    );
  };
  const getDefaultSearch = () => {
    return (
      <div className="search">
        <GSInput
          textValue={name}
          rightIconClick={clearText}
          rightIcon={faTimesCircle}
          leftIcon={faSearch}
          onChange={searchChanged}
          placeholder="Search Access Lists..."
        ></GSInput>
      </div>
    );
  };
  return (
    <organization-access-lists>
      {getListPage("Access Lists")}
    </organization-access-lists>
  );
};

export default OrganizationAccessLists;
